// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".k50eSDXn8SbtdGWQX8Hg {\n  display: flex;\n  justify-content: center;\n  flex-direction: rows;\n}\n", "",{"version":3,"sources":["webpack://./src/components/FavoritesList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB","sourcesContent":[".FavoritesList {\n  display: flex;\n  justify-content: center;\n  flex-direction: rows;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"FavoritesList": "k50eSDXn8SbtdGWQX8Hg"
};
export default ___CSS_LOADER_EXPORT___;
